import {
  DeleteOutlined,
  EditOutlined,
  FilePdfOutlined,
} from '@ant-design/icons';

export const consignmentOrderBillingTableOpt = () => {
  return [
    {
      label: 'Editar',
      key: 'edit',
      icon: <EditOutlined />,
      privilege: 'edit',
    },
    {
      label: 'Cancelar',
      key: 'cancel',
      icon: <DeleteOutlined />,
      privilege: 'delete',
    },
    {
      label: 'PDF',
      key: 'pdf',
      icon: <FilePdfOutlined />,
      privilege: 'approve',
    },
  ];
};

export const filterConst = {
  DELETE: 'delete',
  EDIT: 'edit',
  PDF: 'pdf',
};

export const consignOrderBillingStatusConst = {
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  CANCELED: 'Cancelada',
  DEFAULT: 'Desconocido',
};

export const consignOrderBillingConst = {
  header: 'Factura de consigna',
  prefix: '#',
  duplicateAllotment: 'Ya hay un producto con este lote',
  create: 'Crear factura de consigna',
  edit: 'Editar factura de consigna',
  paid: 'Pagada',
};

export const payStatus = [
  { label: 'Pendiente', value: 'Pendiente' },
  { label: 'Pagada', value: 'Pagada' },
];

export const consignmentOrderBillingModalConst = {
  provider: 'Proveedor',
  orderNumber: 'Número de orden',
  arrivalDate: 'Fecha llegada',
  orderStatus: 'Estado orden',
  tax: 'IVA',
  total: 'Total',
  comments: 'Comentarios',
  payMethod: 'Forma de pago',
  billingStatus: 'Estado de pago',
  paidAt: 'Fecha de pago',
  productName: 'Nombre de producto',
  quantityReceived: 'Cant. Recibida',
  quantityBilled: 'Cant. Facturada',
  noData: '-',
};
